import React, { useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import HistoricalPerformance from "./historicPerformance";

ChartJS.register(ArcElement, Tooltip, Legend);

const PerformanceSection = ({
  riskProfile,
  data,
  stockCode,
  totalPercentage,
  componentName,
}) => {
  const [selectedFilter, setSelectedFilter] = useState("All");
  const timeRanges = ["10y", "5y", "1y", "3m", "1m"];
  const filters = ["All", "IOZ", "BPH", "IQQ", "APLL", "TSL"];

  // Dynamic colors for each slice
  const filteredData = data.filter((item) => item.allocation > 0);

  // Prepare labels and allocations for the donut chart
  const labels = filteredData.map((item) => item.productName);
  const allocations = filteredData.map((item) => item.allocation);

  // Dynamic colors for each slice
  const colors = filteredData.map((item) => "#" + item.productColour);

  // Donut chart data configuration
  const donutData = {
    labels: labels, // Product names
    datasets: [
      {
        label: "Allocation (%)",
        data: allocations, // Allocation values
        backgroundColor: colors, // Dynamic colors
        borderWidth: 0,
      },
    ],
  };

  // Donut chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Disable legend on the donut chart
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            return `${tooltipItem.label}: ${value}%`;
          },
        },
      },
    },
    cutout: "65%", // Creates the hole in the center for the donut chart
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
    // Handle your filtering logic here
  };

  return (
    <div className="container mx-auto p-4 space-y-8">
      {/* Top Header Section */}
      <h2 className="text-lg font-semibold">
        Caprock Model Portfolio - {riskProfile}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 gap-4 text-sm">
            {filteredData.map((item, index) => (
              <div
                key={item.productId}
                className="flex flex-col items-start break-words whitespace-normal"
              >
                {/* Product Name */}
                <span className="font-medium text-sm text-[#A6A6A6] w-full break-words">
                  {item.productName}
                </span>

                {/* Allocation Percentage */}
                <span
                  className="text-md font-medium mt-1 break-words"
                  style={{ color: `#${item.productColour}` }}
                >
                  {item.allocation}%
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Donut Chart */}
        <div className="flex justify-end">
          <div className="w-full md:w-2/3 lg:w-1/2">
            <Doughnut data={donutData} options={options} />
          </div>
        </div>
      </div>
      {/* Historical Performance Section */}
      <div className="space-y-4">
        {totalPercentage > 0 && (
          <HistoricalPerformance
            stockCode={stockCode}
            componentName={componentName}
            totalPercentage={totalPercentage}
          />
        )}
      </div>
    </div>
  );
};

export default PerformanceSection;
